import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
const sketchTool: any = {
  polygon: {
    name: 'polygon',
    initMessage: 'Click to start drawing',
    beforeFirstVertexMessage: 'Click to continue drawing',
    afterFirstVertexMessage:
      'Click to continue drawing or double-click to complete'
  },
  circle: {
    name: 'circle',
    initMessage: 'Click and drag to draw then release to finish',
    beforeFirstVertexMessage: 'Click and drag to draw then release to finish',
    afterFirstVertexMessage: 'Click and drag to draw then release to finish'
  },
  polyline: {
    name: 'polyline',
    initMessage: 'Click to start drawing',
    beforeFirstVertexMessage:
      'Click to continue drawing or double-click to complete',
    afterFirstVertexMessage:
      'Click to continue drawing or double-click to complete'
  }
};
const DrawingTooltip: React.FC<Props> = ({
  view,
  sketchView,
  sketchToolType,
  setShowDrawingTooltip
}) => {
  const [currentMessage, setCurrentMessage] = useState<string>('');
  const sketchToolTypeRef: any = useRef<any>(sketchToolType);
  const currentMessageRef: any = useRef<any>(currentMessage);

  useEffect(() => {
    if (sketchView) {
      const createStartFn = () => {
        if (sketchTool && sketchTool[sketchToolTypeRef.current]) {
          sketchTool[sketchToolTypeRef.current].beforeFirstVertexMessage &&
            setMessage(
              sketchTool[sketchToolTypeRef.current].beforeFirstVertexMessage
            );
        }
      };
      const createCompleteFn = () => {
        setMessage('');
      };
      const createFn = () => {
        if (
          sketchTool &&
          sketchTool[sketchToolTypeRef.current] &&
          sketchTool[sketchToolTypeRef.current].afterFirstVertexMessage &&
          currentMessageRef.current !==
            sketchTool[sketchToolTypeRef.current].afterFirstVertexMessage
        ) {
          setMessage(
            sketchTool[sketchToolTypeRef.current].afterFirstVertexMessage
          );
        }
      };
      sketchView.on('create-start', createStartFn);
      sketchView.on('create-complete', createCompleteFn);
      sketchView.on('create', createFn);
    }
  }, [sketchView]);

  useEffect(() => {
    if (view) {
      const pointerMoveFn = (e: any) => {
        setShowDrawingTooltip(true);
        if (sketchToolTypeRef.current !== 1) {
          const dt = document.getElementById('drawingTooltip');
          if (dt) {
            let left = e.x + 301;
            let top = e.y + 140;
            if (left > view.width + 310 / 3) {
              left = e.x + 117;
            }
            if (top > view.height + 145 / 2) {
              top = e.y + 71;
            }
            dt.style.left = `${left}px`;
            dt.style.top = `${top}px`;
            dt.style.display = 'block';
          }
        }
      };

      const pointerLeaveFn = () => {
        setShowDrawingTooltip(false);
      };

      const pointerEnterFn = () => {
        setShowDrawingTooltip(true);
      };

      view.on('pointer-move', pointerMoveFn);
      view.on('pointer-leave', pointerLeaveFn);
      view.on('pointer-enter', pointerEnterFn);
    }
  }, [view, setShowDrawingTooltip]);

  useEffect(() => {
    if (
      sketchToolType !== null &&
      sketchToolType !== 'selector' &&
      sketchToolType !== 'upload'
    ) {
      setMessage(sketchTool[sketchToolType].initMessage);
      sketchToolTypeRef.current = sketchToolType;
    }
  }, [sketchToolType]);
  function setMessage(data: string) {
    currentMessageRef.current = data;
    setCurrentMessage(data);
  }
  if (currentMessage && !_.isEmpty(currentMessage)) {
    return (
      <div id="drawingTooltip" className="drawing-tooltip">
        <div>{currentMessage || ''}</div>
      </div>
    );
  } else {
    return <div id="drawingTooltip" />;
  }
};

type Props = {
  view: any;
  sketchView: any;
  sketchToolType: string;
  setShowDrawingTooltip: Function;
};

DrawingTooltip.displayName = 'DrawingTooltip';

export default React.memo(DrawingTooltip);
